import { ReactElement } from "react";
import { offerMeteredTransforms } from "@stores/config/utils";
import { AddOnCard } from "@addons/components/AddOnCard";
import { SwitchToMeteredTransformsCTA } from "@addons/components/SwitchToMeteredTransformsCTA";
import { LegacyTransformsManageLink } from "@addons/components/LegacyTransformsManageLink";
import { useAddOnContext } from "../hooks";
import { IAddOnSlotProps, IFlatAddOnDescriptor } from "../types";
import { subscribedBaseFee } from "../utils";

export function ManageCard({
  addOn: ctx,
}: IAddOnSlotProps<IFlatAddOnDescriptor>): ReactElement {
  const meteredOffered = offerMeteredTransforms(ctx.config);
  const metered = useAddOnContext("transforms-basic-metered");

  return (
    <AddOnCard
      isYearly={ctx.isYearly}
      productType="transforms-basic"
      title={ctx.title}
      price={subscribedBaseFee(ctx)}
      description={
        !meteredOffered &&
        "Clean up and model your data right from within Metabase."
      }
      usage={
        meteredOffered && (
          <SwitchToMeteredTransformsCTA legacy={ctx} metered={metered} />
        )
      }
      extra={<LegacyTransformsManageLink addOn={ctx} />}
    />
  );
}
